<mat-icon>nightlight_round</mat-icon><mat-slide-toggle (click)="toggleTheme()"><mat-icon>brightness_7</mat-icon></mat-slide-toggle>